import { useEffect } from "react";

import useDataContext from "../providers/DataProvider/useDataContext";

// RAMA DE RESPALDO (temp-without-cloudbeds): sin motor de reservas embebido.
// Los botones de reserva del sitio ya apuntan directo al motor de reservas
// externo de Cloudbeds; esta página solo cubre a quien llegue directo a la
// ruta (link viejo, buscador, favoritos) y lo redirige en la misma pestaña.
// Se usa 'location.replace' y no 'window.open' porque este último, sin un
// gesto del usuario de por medio, es bloqueado por los bloqueadores de pop-ups.
// Para volver al motor de reservas embebido, usar la rama master.
const BookPage: React.FC = () => {
    const { data } = useDataContext();

    useEffect(() => {
        window.location.replace(data.pages.bookPage.externalUrl);
    }, [data.pages.bookPage.externalUrl]);

    return null;
}

export default BookPage;
